import type {
    MutableToolStepKey,
} from '@toolproof-core/lib/_contract/workflow-overlay';


export function buildPlaceholderStepKey(args: {
    ownerMacroStepKey: string;
    ownerCaseIndex: number;
    slot: 'when' | 'what';
}): MutableToolStepKey {
    const normalizedOwnerKey = args.ownerMacroStepKey.replace(/[^a-zA-Z0-9_-]/g, '_');
    return `TOOL_STEP-placeholder-${normalizedOwnerKey}-${args.ownerCaseIndex}-${args.slot}` as MutableToolStepKey;
}